import { render, staticRenderFns } from "./promo-about.vue?vue&type=template&id=2c543c0a"
import script from "./promo-about.vue?vue&type=script&lang=js"
export * from "./promo-about.vue?vue&type=script&lang=js"
import style0 from "./promo-about.vue?vue&type=style&index=0&id=2c543c0a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports